import { createFileRoute } from '@tanstack/react-router'
import { requireMember } from '@/lib/auth-guards'
import { MyMembershipPage } from '@/features/my-account/my-membership-page'

export const Route = createFileRoute('/_authenticated/my-membership')({
  beforeLoad: requireMember,
  component: MyMembershipPage,
})
